import { IFormError } from '../components/Forms/types';

export const resolve422Errors = (errors): IFormError[] => Object.keys(errors).map((field) => ({ id: field, message: errors[field][0] }));
